export default __webpack_public_path__ + "static/media/factory__34.56aa0858.jpg";